import {
  createBrowserRouter,
  RouterProvider,
  Navigate,
} from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Cartoon from "./pages/Cartoon";
import { AuthProvider } from "./adminpanel/AuthContext";
import { CartProvider } from "./context/CartContext";

// Public Pages
import Home from "./Routes/Home";
import ProductCards from "./pages/ProductCards";
import About from "./pages/About";
import Faqs from "./pages/Faqs";
import ProductDetails from "./pages/ProductDetails";
import Payment from "./pages/Payment";
import Contact from "./pages/Contact";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsndServices from "./pages/TermsndServices";
import ReturnPolicy from "./pages/ReturnPolicy";
import Shippingndrefund from "./pages/Shippingndrefund";
import Login from "./components/Login";
import Cart from "./pages/Cart";
import ProductCart from "./components/ProductCart";
import Checkout from "./pages/Checkout";
import MyOrders from "./pages/MyOrders";

// Admin Components
import AdminLogin from "./adminpanel/AdminLogin";
import AdminLayout from "./adminpanel/AdminLayout";
import Dashboard from "./adminpanel/Dashboard";
import AdminProducts from "./adminpanel/Products";
import Customers from "./adminpanel/CustomerAvailabilityReport";
import ProductCreate from "./adminpanel/ProductCreate";
import ProductUpdate from "./adminpanel/ProductUpdate";
import AllOrders from "./adminpanel/AllOrders";
import TodayOrders from "./adminpanel/TodayOrders";
import WeeklyOrders from "./adminpanel/WeeklyOrders";
import MonthlyOrder from "./adminpanel/MonthlyOrders";
import OrderHistory from "./adminpanel/OrderHistory";
import EditOrder from "./adminpanel/EditOrder";
import Invoice from "./adminpanel/Invoice";
import Users from "./adminpanel/Users";
import Profile from "./pages/Profile";
// Layout wrapper with Header always visible (Public)
const Layout = ({ children }) => (
  <>
    <Header />
    <main className="">{children}</main>
    <Cartoon />
    <Footer />
  </>
);

const router = createBrowserRouter([
  // --- Public Routes ---
  {
    path: "/",
    element: (
      <Layout>
        <Home />
      </Layout>
    ),
  },
  {
    path: "/product",
    element: (
      <Layout>
        <ProductCards />
      </Layout>
    ),
  },
  {
    path: "/about",
    element: (
      <Layout>
        <About />
      </Layout>
    ),
  },
  {
    path: "/faqs",
    element: (
      <Layout>
        <Faqs />
      </Layout>
    ),
  },

  // Product & Cart
  {
    path: "/product-details/:id?",
    element: (
      <Layout>
        <ProductDetails />
      </Layout>
    ),
  },
  {
    path: "/product-cart/:id",
    element: (
      <Layout>
        <ProductCart />
      </Layout>
    ),
  },
  {
    path: "/cart",
    element: (
      <Layout>
        <Cart />
      </Layout>
    ),
  },
  {
    path: "/checkout",
    element: (
      <Layout>
        <Checkout />
      </Layout>
    ),
  },
  {
    path: "/my-orders",
    element: (
      <Layout>
        <MyOrders />
      </Layout>
    ),
  },
{
    path: "/profile",
    element: (
      <Layout>
        <Profile/>
      </Layout>
    ),
  },
  // Static Pages
  {
    path: "/payment",
    element: (
      <Layout>
        <Payment />
      </Layout>
    ),
  },
  {
    path: "/contact",
    element: (
      <Layout>
        <Contact />
      </Layout>
    ),
  },
  {
    path: "/privacy-policy",
    element: (
      <Layout>
        <PrivacyPolicy />
      </Layout>
    ),
  },
  {
    path: "/terms-and-services",
    element: (
      <Layout>
        <TermsndServices />
      </Layout>
    ),
  },
  {
    path: "/return-policy",
    element: (
      <Layout>
        <ReturnPolicy />
      </Layout>
    ),
  },
  {
    path: "/shipping-and-refund-policy",
    element: (
      <Layout>
        <Shippingndrefund />
      </Layout>
    ),
  },
  {
    path: "/login",
    element: (
      <Layout>
        <Login />
      </Layout>
    ),
  },

  // --- Admin Routes ---
  { path: "/admin-login", element: <AdminLogin /> },

  // Protected Admin Panel
  {
    path: "/admin-panel",
    element: <AdminLayout />, // <--- This component MUST have <Outlet />
    children: [
      // Redirect /admin-panel to /admin-panel/dashboard
      { index: true, element: <Navigate to="dashboard" replace /> },

      // Sub-routes (Rendered inside AdminLayout's Outlet)
      { path: "dashboard", element: <Dashboard /> },
      { path: "products", element: <AdminProducts /> },
      { path: "products/create", element: <ProductCreate /> },
      { path: "products/:id/edit", element: <ProductUpdate /> },
      { path: "customers", element: <Customers /> },
      { path: "orders/all", element: <AllOrders /> },
      { path: "orders/today", element: <TodayOrders /> },
      { path: "orders/weekly", element: <WeeklyOrders /> },
      { path: "orders/monthly", element: <MonthlyOrder /> },
      { path: "orders/history", element: <OrderHistory /> },
    { path: "orders/edit/:id", element: <EditOrder/>},
      { path: "orders/invoice/:id", element: <Invoice /> },
      { path: "users", element: <Users /> },
    ],
  },

  // Catch all (Optional)
  { path: "*", element: <Navigate to="/" replace /> },
]);

export default function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <RouterProvider router={router} />
      </CartProvider>
    </AuthProvider>
  );
}
